// Prevent redeclaration in Shopify (script loaded multiple times)
if (!window.MulticolumnVideoItem) {
  window.MulticolumnVideoItem = class MulticolumnVideoItem extends HTMLElement {
    constructor() {
      super();
      this.video = null;
      this.playButton = null;
      this.isPreviewPlaying = false;
      this.previewTimeout = null;
      this.previewDuration = parseInt(this.dataset.previewDuration, 10) || 1500;

      // Bind once (important for cleanup)
      this.handleMouseEnter = this.handleMouseEnter.bind(this);
      this.handleMouseLeave = this.handleMouseLeave.bind(this);
      this.handlePlayButtonClick = this.handlePlayButtonClick.bind(this);
      this.handleVideoPause = this.handleVideoPause.bind(this);
      this.handleVideoPlay = this.handleVideoPlay.bind(this);
      this.handleVideoEnded = this.handleVideoEnded.bind(this);
    }

    connectedCallback() {
      this.init();
    }

    disconnectedCallback() {
      this.cleanup();
    }

    init() {
      this.video = this.querySelector('video');
      this.playButton = this.querySelector('.video-play-button');

      if (!this.video || !this.playButton) return;

      // Preview hover
      this.addEventListener('mouseenter', this.handleMouseEnter);
      this.addEventListener('mouseleave', this.handleMouseLeave);

      // Play button
      this.playButton.addEventListener('click', this.handlePlayButtonClick);

      // Video events
      this.video.addEventListener('pause', this.handleVideoPause);
      this.video.addEventListener('play', this.handleVideoPlay);
      this.video.addEventListener('ended', this.handleVideoEnded);
    }

    handleMouseEnter() {
      if (this.classList.contains('playing')) return;

      this.isPreviewPlaying = true;
      this.video.currentTime = 0;
      this.video.play();
      this.classList.add('previewing');

      this.previewTimeout = setTimeout(() => {
        if (this.isPreviewPlaying && !this.classList.contains('playing')) {
          this.video.pause();
          this.video.currentTime = 0;
          this.classList.remove('previewing');
          this.isPreviewPlaying = false;
        }
      }, this.previewDuration);
    }

    handleMouseLeave() {
      if (!this.isPreviewPlaying || this.classList.contains('playing')) return;

      clearTimeout(this.previewTimeout);
      this.video.pause();
      this.video.currentTime = 0;
      this.classList.remove('previewing');
      this.isPreviewPlaying = false;
    }

    handlePlayButtonClick(e) {
      e.stopPropagation();
      this.clearPreviewState();

      if (this.video.paused) {
        this.video.play();
        this.classList.add('playing');
      } else {
        this.video.pause();
        this.classList.remove('playing');
      }
    }

    handleVideoPause() {
      if (!this.isPreviewPlaying) {
        this.classList.remove('playing');
      }
    }

    handleVideoPlay() {
      if (!this.isPreviewPlaying) {
        this.classList.add('playing');
      }
    }

    handleVideoEnded() {
      this.clearPreviewState();
      this.classList.remove('playing');
    }

    clearPreviewState() {
      clearTimeout(this.previewTimeout);
      this.isPreviewPlaying = false;
      this.classList.remove('previewing');
    }

    cleanup() {
      this.clearPreviewState();

      this.removeEventListener('mouseenter', this.handleMouseEnter);
      this.removeEventListener('mouseleave', this.handleMouseLeave);

      if (this.playButton) {
        this.playButton.removeEventListener('click', this.handlePlayButtonClick);
      }

      if (this.video) {
        this.video.removeEventListener('pause', this.handleVideoPause);
        this.video.removeEventListener('play', this.handleVideoPlay);
        this.video.removeEventListener('ended', this.handleVideoEnded);
      }
    }
  };
}

// Register custom element safely
if (!customElements.get('multicolumn-video-item')) {
  customElements.define(
    'multicolumn-video-item',
    window.MulticolumnVideoItem
  );
}
